import React from 'react'
import PropTypes from 'prop-types'

import {
  Box,
  breakpoints,
  Container,
  InfoSection,
  ResponsiveImage
} from 'ui/acro'

const HalfBleed = ({
  images,
  rightAlign,
  headline,
  body,
  url,
  children,
  cta,
  ...rest
}) => {
  const imagesArray = [
    {
      src: images.src,
      breakpoint: breakpoints[0]
    }
  ]

  return (
    <Box position='relative' {...rest}>
      <Box
        position={['relative', null, null, 'absolute']}
        top='0'
        right={!rightAlign && '0'}
        left={rightAlign && '0'}
      >
        <ResponsiveImage
          src={images.src}
          alt={images.alt}
          imagesArray={imagesArray}
          width={['100%', null, null, '55vw']}
          objectFit='cover'
        />
      </Box>

      <Container
        height={['auto', null, null, 'calc((55vw / 16) * 9)']} // This will cause the entire <Container/> to be the height of the image, allowing us to center the text element.
        centerProps={{
          justifyContent: 'center'
        }}
      >
        <InfoSection
          headline={headline}
          body={body}
          maxWidth={['auto', null, null, '480px']} // design is 500px @ +1200px, however a 55vw image + 50 px padding leaves us with only 490px left. Remove 10 for padding and voila.
          alignSelf={['center', null, null, rightAlign ? 'flex-end' : 'start']}
          mt={['32px', null, null, '0px']}
        >
          {children}
        </InfoSection>
      </Container>
    </Box>
  )
}

HalfBleed.propTypes = {
  body: PropTypes.string,
  children: PropTypes.node,
  cta: PropTypes.string,
  headline: PropTypes.string,
  images: PropTypes.object,
  rightAlign: PropTypes.bool,
  url: PropTypes.string
}

export default HalfBleed
